import { Flex } from 'antd'
import { CheckOutlined } from '@ant-design/icons'
import Text from 'shared/components/typography/Text'
import { IVoice } from '@/pages/Donation/api/streamer/types'
import AudioPlayer from '@/components/AudioPlayer'

type Props = {
  voice: IVoice
  isSelected: boolean
  onOptionClick: () => void
}

export default function OptionContent({ voice, onOptionClick, isSelected }: Props) {
  return (
    <Flex key={voice.name} align="center" gap={10} onClick={onOptionClick}>
      <AudioPlayer audioSrc={voice.sample_uri} />
      <Text type="primary">{voice.nickname}</Text>
      {isSelected && <CheckOutlined style={{ color: 'var(--accent-light)', marginLeft: 'auto' }} />}
    </Flex>
  )
}
